import axios from 'axios'

export const completeRegistration = (supplierId, token, password) =>
  axios
    .post(`/public/registration/complete/${token}?supplierId=${supplierId}`, {
      password
    })
    .then((res) => res.data)

export const fetchRegistrationInvitation = (supplierId, token) =>
  axios
    .get(`/public/registration/${token}?supplierId=${supplierId}`)
    .then((res) => res.data)
